import { anInsight, mockTopInsightQueryOperationQuery } from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockTopInsightQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          insights: {
            __typename: 'InsightPage',
            objects: [anInsight()],
          },
        },
      });
    }
  ),
];
